import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents } from 'presto-mini-apps-lib';
import { defaultOverlayStyle, ButtonHeight, getOSUserAgent, OSType } from '../../constants/appState';
import TextInputWithLabel from '../../components/TextInputWithLabel';
import { appService } from '../../services';
import {
    term_loyaltyButtonConfirm,
    term_loyaltyAccount,
    phrase_LoyaltyInputPin,
    term_loyaltyPin,
    phrase_LoyaltyPinErrorMessage
} from '../../constants/text';

class LoyaltyTypePinModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputError: false,
            submitDisabled: true,
            formValue: {
                inputPin: ''
            },
        };
    }

    componentDidUpdate(prevProps) {
        const {
            clearField,
        } = this.props;

        if (prevProps.clearField !== clearField) {
            if (clearField) {
                this.setState({
                    inputError: false,
                    submitDisabled: true,
                });
            }
        }
    }

    onInputStateChangeHandler = (input, elmName) => {
        const { loyaltyItem } = this.props;

        this.setState({
            formValue: {
                ...this.state.formValue,
                inputPin: input
            },
            submitDisabled: !(!!input && input.length > 0)
        });
    };

    checkForm = () => {
        const { formValue } = this.state;

        const input = formValue.inputPin;
        if (!!input && input.length > 0) {
            this.setState({
                inputError: false,
            });
            return true;
        } else {
            this.setState({
                inputError: false,
            });
            return false;
        }
    };

    onSubmitHandler = (e) => {
        e.preventDefault();
        const res = this.checkForm();
        if (res) {
            this.doLoyaltyRevalidation();
        }
    };

    doLoyaltyRevalidation = () => {
        const { formValue } = this.state;
        const { loyaltyItem } = this.props;

        console.log("Status: Performing loyalty revalidation...");
        appService.apiLoyaltyRevalidate({
            paymentCode: window.PrestoPayObj.paymentCode,
            loyaltyType: loyaltyItem.loyaltyId,
            secret: formValue.inputPin,
            onSuccess: this.onLoyaltyRevalidationSuccessHandler,
            onError: this.onLoyaltyRevalidationFailedHandler
        });
    };

    onLoyaltyRevalidationSuccessHandler = (resp) => {
        const { onSubmit } = this.props;

        if(!!resp.success) {
            console.log("Status: Loyalty revalidation success");

            this.setState({
                inputError: false,
            });

            if (typeof onSubmit === 'function') {
                onSubmit(resp.data.loyaltyMethod);
            }
        } else {
            this.setState({
                inputError: true,
            });
        }
    };

    onLoyaltyRevalidationFailedHandler = (data) => {
        this.setState({
            inputError: true,
        });
    };

    render() {
        const {
            submitDisabled,
            inputError,
        } = this.state;
        const {
            appState,
            clearField,
            isOpen,
            onClose,
            loyaltyItem,
        } = this.props;

        return (
            <React.Fragment>
                <ModalOverlayWrapper className={[
                    'modal-overlay',
                    (!!isOpen ? ' show' : '')
                ].join('')}>
                    <div className="overlay" />
                    <ModalPanelWrapper className="popup-panel">
                        <div className="panel-control">
                            <button className="close-button" onClick={onClose} />
                        </div>
                        <div className="panel-header">
                            <div className="logo">{ !!loyaltyItem ? (loyaltyItem.logo) : '' }</div>
                        </div>
                        <div className="panel-body">
                            <div className="loyalty-row padded">
                                {phrase_LoyaltyInputPin}
                            </div>
                            <div className="loyalty-row">
                                <div className="label">{term_loyaltyAccount}</div>
                                <div className="value">{ !!loyaltyItem ? loyaltyItem.memberId : '' }</div>
                            </div>
                        </div>
                        <div className="panel-body">
                            <div className="title">{term_loyaltyPin}</div>
                            <div className="amount">
                                <TextInputWithLabel
                                    inputName="loyaltyPin"
                                    inputStyle="boxedInput"
                                    type={ (getOSUserAgent() !== OSType.ANDROID &&
                                        getOSUserAgent() !== OSType.IOS)
                                        ? 'password'
                                        : 'number-password' }
                                    errorMessage={ phrase_LoyaltyPinErrorMessage }
                                    maxLength={6}
                                    inputStateChangeHandler={ this.onInputStateChangeHandler }
                                    isError={ inputError }
                                    clearField={ clearField }
                                />
                            </div>
                        </div>
                        <div className="panel-action">
                            <PrestoAppComponents.Button
                                height={ ButtonHeight + 'px' }
                                className="confirm-button"
                                disabled={ submitDisabled }
                                onClick={ this.onSubmitHandler }
                            >{term_loyaltyButtonConfirm}</PrestoAppComponents.Button>
                        </div>
                    </ModalPanelWrapper>
                </ModalOverlayWrapper>
            </React.Fragment>
        );
    }
}

export default LoyaltyTypePinModal;


const commonBorderRadius = 6; // 6px
const commonBoxShadow = '0 1px 4px rgba(0, 0, 0, 0.1)';

const ModalOverlayWrapper = styled.div`
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 100;
    
    & .overlay {
        ${defaultOverlayStyle}
    }
    
    &.show {
        display: flex;
    }
`;

const ModalPanelWrapper = styled.div`
    position: relative;
    width: 100%;
    border-radius: ${commonBorderRadius}px;
    box-shadow: ${commonBoxShadow};
    background-color: ${PrestoAppTheme.colors.white};
    border: solid ${PrestoAppTheme.colors.white} 1pt;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    
    & .panel-control {
        padding: 0;
        box-sizing: border-box;
        flex: 1;
        
        & .close-button {
            height: 0.75em;
            width: 0.75em;
            padding: 0px;
            margin: 0px;
            background: transparent url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAGaADAAQAAAABAAAAGQAAAAB7O7VkAAABkElEQVRIDa2VwVGEMBSGIR6A244l2IB2IByhChvQsRVLoAJ3PHJBO3ArsAP1Bsyw4P8zGyYLCSSs78BLXpL/C8lL4nuwsix3TdPcB0HwkSTJL2OX2FRPMFBV1Vff93t4VMvdJYCiKO6kXl3Xr9QSCMS+7w/C8OywGURA27al1IN+zEmLLMv2qBxIpG0FaQAeVueFyy8oHIZhDLcZpANAL8cPPMN7Pj80/hbW8B3FW9ZpmMlnFEWYjDkZTIA0TR8GEXxGCAOuIBsAdc8gLiBbgBZiA3IBGCFLICHEU9d1b0qasnuu7gEDqs2WS2007NERgCul3yKA/RYh7KADMX6yVQD7DedEjtB5pi9m/oi246T9G+drOAeT+Ky6CuEmcw8wUl0iCl3bXkGLEF0W4YD+yKnaXkFGiA4A8Rw3wA280xWk3XgTQKapLhmWrqAZZA0gl8oFdAaxBbiCRogrwAU0QLYCbEHDGz95MjnW6iRLCA+s7uHTvvGnQU6AJRDatG/8JoAJJN942e5xX8bKPxRUvT+Ek5OUznWWswAAAABJRU5ErkJggg==") no-repeat scroll center center / contain;
            border: 0px none;
            cursor: pointer;
        }
    }

    & .panel-header {
        padding: 0.5rem 0;
        text-align: center;
        box-sizing: border-box;
        flex: 1;
        
        & .logo {
            margin: 0 auto;
            
            & img {
                width: 40%;
            }
        }
    }

    & .panel-body {
        padding: 0.5rem 0;
        text-align: left;
        box-sizing: border-box;
        flex: 3;
        font-weight: 300;
        font-size: 0.75rem;
        border-top: 1px solid ${PrestoAppTheme.colors.baseSnowDark};
        
        & .loyalty-row {
            display: flex;
            width: 100%;
            justify-content: space-between;
            line-height: 1.25rem;
        
            & .label {
            }
            
            & .value {
                font-weight: 400;
            }
        }
        
        & .padded {
            padding-bottom: ${PrestoAppTheme.layout.smallGap};
        }
        
        & .title {
        }
        
        & .amount {
            padding-top: ${PrestoAppTheme.layout.smallGap};
            
            & .error-message {
                line-height: 1.2rem;
            }
        }
    }

    & .panel-action {
        display: flex;
        padding: ${PrestoAppTheme.layout.smallGap} 0;
        text-align: right;
        box-sizing: border-box;
        justify-content: flex-end;
        flex: 1;
        bottom: 0;
        right: 0;
        opacity: 100%;
    }
`;

